import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "exam-time"
};
const _hoisted_2 = {
  key: 1,
  class: "paper-context"
};
const _hoisted_3 = {
  key: 0,
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_4 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_5 = {
  key: 0,
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_6 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_7 = {
  key: 0,
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_8 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_9 = {
  key: 0,
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_10 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_11 = {
  key: 0,
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_12 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_13 = {
  key: 3,
  class: "loading"
};
const _hoisted_14 = {
  class: "loading-box"
};
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  class: "tips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_vocabulary_mcq = _resolveComponent("vocabulary_mcq");
  const _component_mcq = _resolveComponent("mcq");
  const _component_saq = _resolveComponent("saq");
  const _component_pwco = _resolveComponent("pwco");
  const _component_proofreading = _resolveComponent("proofreading");
  const _component_sequencing = _resolveComponent("sequencing");
  const _component_mm_sequencing = _resolveComponent("mm_sequencing");
  const _component_mm_drag = _resolveComponent("mm_drag");
  const _component_mm_mcq = _resolveComponent("mm_mcq");
  const _component_mcq_mmcq = _resolveComponent("mcq_mmcq");
  const _component_writing_listen = _resolveComponent("writing_listen");
  const _component_writing = _resolveComponent("writing");
  const _component_mm = _resolveComponent("mm");
  const _component_MockMenuBox = _resolveComponent("MockMenuBox");
  return _openBlock(), _createElementBlock(_Fragment, null, [$setup.paperInfo[$setup.paperNo] ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "margin-right": "5px",
      "font-size": "20px"
    },
    icon: $setup.Timer,
    size: "large"
  }, null, 8, ["icon"]), _createElementVNode("p", null, [_cache[14] || (_cache[14] = _createTextVNode(" 考试时间", -1)), _createElementVNode("span", null, _toDisplayString($setup.timeText), 1)]), _createVNode(_component_el_button, {
    color: "#1d5595",
    type: "success",
    size: "large",
    onClick: _cache[0] || (_cache[0] = $event => $setup.finishExam(1))
  }, {
    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("交 卷", -1)]))]),
    _: 1
  })])) : _createCommentVNode("", true), $setup.paperInfo[$setup.paperNo] ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$setup.paperInfo[$setup.paperNo].skill == 'S0' && $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'mmcq' ? (_openBlock(), _createBlock(_component_vocabulary_mcq, {
    key: 0,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers
  }, null, 8, ["questionInfo", "onSetAnswer", "allAnswers"])) : ($setup.paperInfo[$setup.paperNo].skill == 'S0' || $setup.paperInfo[$setup.paperNo].skill == 'S1' || $setup.paperInfo[$setup.paperNo].skill == 'S3' || $setup.paperInfo[$setup.paperNo].skill == 'S9') && ($setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'mcq' || $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'mmcq' || $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'judge') ? (_openBlock(), _createBlock(_component_mcq, {
    key: 1,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers
  }, {
    default: _withCtx(() => [$setup.paperInfo[$setup.paperNo].items[$setup.itemNo].mediaName ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      style: {
        "width": "25px",
        "height": "25px"
      },
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.audioStop && _ctx.audioStop(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[2] || (_cache[2] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [[_vShow, $setup.audioStatus == 'over']])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["questionInfo", "onSetAnswer", "allAnswers"])) : $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'saq' ? (_openBlock(), _createBlock(_component_saq, {
    key: 2,
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    skill: $setup.paperInfo[$setup.paperNo].skill
  }, {
    default: _withCtx(() => [$setup.paperInfo[$setup.paperNo].items[$setup.itemNo].mediaName ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      style: {
        "width": "25px",
        "height": "25px"
      },
      onClick: _cache[3] || (_cache[3] = (...args) => _ctx.audioStop && _ctx.audioStop(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[4] || (_cache[4] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [[_vShow, $setup.audioStatus == 'over']])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["onSetAnswer", "allAnswers", "questionInfo", "skill"])) : $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'pwco' ? (_openBlock(), _createBlock(_component_pwco, {
    key: 3,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'proofreading' ? (_openBlock(), _createBlock(_component_proofreading, {
    key: 4,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'sequencing' ? (_openBlock(), _createBlock(_component_sequencing, {
    key: 5,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, {
    default: _withCtx(() => [$setup.paperInfo[$setup.paperNo].items[$setup.itemNo].mediaName ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      style: {
        "width": "25px",
        "height": "25px"
      },
      onClick: _cache[5] || (_cache[5] = (...args) => _ctx.audioStop && _ctx.audioStop(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[6] || (_cache[6] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [[_vShow, $setup.audioStatus == 'over']])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo[$setup.paperNo].skill == 'S1' && ($setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm' || $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-drag') ? (_openBlock(), _createBlock(_component_mm_sequencing, {
    key: 6,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, {
    default: _withCtx(() => [$setup.paperInfo[$setup.paperNo].items[$setup.itemNo].mediaName ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      style: {
        "width": "25px",
        "height": "25px"
      },
      onClick: _cache[7] || (_cache[7] = (...args) => _ctx.audioStop && _ctx.audioStop(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[8] || (_cache[8] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [[_vShow, $setup.audioStatus == 'over']])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-drag' ? (_openBlock(), _createBlock(_component_mm_drag, {
    key: 7,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-mcq' ? (_openBlock(), _createBlock(_component_mm_mcq, {
    key: 8,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'mcq' || $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'mmcq' || $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'judge' ? (_openBlock(), _createBlock(_component_mcq_mmcq, {
    key: 9,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'writing' && $setup.paperInfo[$setup.paperNo].skill == 'S1' ? (_openBlock(), _createBlock(_component_writing_listen, {
    key: 10,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, {
    default: _withCtx(() => [$setup.paperInfo[$setup.paperNo].items[$setup.itemNo].mediaName ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      style: {
        "width": "25px",
        "height": "25px"
      },
      onClick: _cache[9] || (_cache[9] = (...args) => _ctx.audioStop && _ctx.audioStop(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[10] || (_cache[10] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_12, null, 512), [[_vShow, $setup.audioStatus == 'over']])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'writing' ? (_openBlock(), _createBlock(_component_writing, {
    key: 11,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo[$setup.paperNo].items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm' ? (_openBlock(), _createBlock(_component_mm, {
    key: 12,
    questionInfo: $setup.paperInfo[$setup.paperNo].items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.paperInfo[0] ? (_openBlock(), _createBlock(_component_MockMenuBox, {
    key: 2,
    paperNo: $setup.paperNo,
    paperInfo: $setup.paperInfo,
    itemNo: $setup.itemNo,
    answers: $setup.cache.answers,
    onChangePaper: _cache[11] || (_cache[11] = no => {
      $setup.saveAudioTime();
      $setup.paperNo = no;
      $setup.setcache();
    }),
    onChangeItem: _cache[12] || (_cache[12] = no => {
      $setup.saveAudioTime();
      $setup.itemNo = no;
      $setup.setcache();
    })
  }, null, 8, ["paperNo", "paperInfo", "itemNo", "answers"])) : _createCommentVNode("", true), $setup.paperInfo[$setup.paperNo] ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("p", _hoisted_15, _toDisplayString($setup.preLoadingText < $setup.paperInfo[$setup.paperNo_S1].items.length ? "正在加载试卷资源" : "加载成功！"), 1), _withDirectives(_createElementVNode("p", null, " 正在加载试卷音频资源..(" + _toDisplayString($setup.preLoadingText) + "/" + _toDisplayString($setup.paperInfo[$setup.paperNo_S1].items.length) + ") ", 513), [[_vShow, $setup.preLoadingText < $setup.paperInfo[$setup.paperNo_S1].items.length]]), _withDirectives(_createElementVNode("p", _hoisted_16, " 如加载过慢，建议关闭浏览器，更换网络环境重试。 ", 512), [[_vShow, $setup.preLoadingText < $setup.paperInfo[$setup.paperNo_S1].items.length]]), _withDirectives(_createElementVNode("p", null, " 加载资源完成，请点击确认开始考试 ", 512), [[_vShow, $setup.preLoadingText == $setup.paperInfo[$setup.paperNo_S1].items.length]]), _createElementVNode("div", null, [_withDirectives(_createVNode(_component_el_button, {
    size: "large",
    type: "primary",
    plain: "",
    onClick: _cache[13] || (_cache[13] = $event => {
      $setup.preLoading = false;
      $setup.setCountDown();
    })
  }, {
    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("确认", -1)]))]),
    _: 1
  }, 512), [[_vShow, $setup.preLoadingText == $setup.paperInfo[$setup.paperNo_S1].items.length]])])])], 512)), [[_vShow, $setup.preLoading]]) : _createCommentVNode("", true)], 64);
}